module.exports = __webpack_public_path__ + "img/human.588e0cde.svg";